<nz-space nzDirection="vertical" style="width: 100%">
  <nz-space-item style="text-align: right;">
    <nz-space>
      <nz-space-item>
        <nz-switch [(ngModel)]="displayMode" [nzCheckedChildren]="'Compact' | locale"
          [nzUnCheckedChildren]="'Detailed' | locale" (ngModelChange)="displayModeChange();"></nz-switch>
      </nz-space-item>
      <!-- <nz-space-item>
        <nz-switch [(ngModel)]="scanMode" [nzCheckedChildren]="'Scan' | locale"
          [nzUnCheckedChildren]="'Manual' | locale" (ngModelChange)="scanModeChange();"></nz-switch>
      </nz-space-item> -->
      <nz-space-item>
        <nz-radio-group [(ngModel)]="dataDisplayMode" (ngModelChange)="dataDisplayModeChange();">
          <label nz-radio-button nzValue="T">
            <i nz-icon nzType="table" nzTheme="outline"></i>
          </label>
          <label nz-radio-button nzValue="C">
            <i nz-icon nzType="appstore" nzTheme="outline"></i>
          </label>
        </nz-radio-group>
      </nz-space-item>
      <!-- <nz-space-item *ngIf="!scanMode">
        <button nz-button nzType="primary" (click)="addNewBatch(undefined);">
          <i nz-icon nzType="plus"></i>
        </button>
      </nz-space-item> -->
    </nz-space>
  </nz-space-item>
  <!-- <nz-space-item *ngIf="scanMode"> -->
  <nz-space-item>
    <nz-space nzDirection="vertical" style="width: 100%">
      <nz-space-item *ngIf="binActivated">
        <nz-select [nzShowSearch]="true" [(ngModel)]="selectedBinLocation" (ngModelChange)="selectedBinChanged();"
          style="width: 100%;" [nzPlaceHolder]="'Bin Location' | locale">
          <nz-option *ngFor="let binLocation of binLocations" [nzValue]="binLocation.AbsEntry"
            [nzLabel]="binLocation.BinCode">
          </nz-option>
        </nz-select>
        <ng-template #ssccIcon>
          <i nz-icon nzType="border" nzTheme="outline"></i>
        </ng-template>
      </nz-space-item>
      <nz-space-item *ngIf="moduleStructure.module.AdditionalInformationParsed
      .ModuleApp === 'itm-wms-360' && ssccHidden == false">
        <nz-input-group [hidden]="!showSupplierSSCCField" [nzPrefix]="ssccIcon" [nzSuffix]="clearSSCC" nzSize="large">
          <input #ssccInput nz-input style="width: 100%;" [(ngModel)]="selectedSSCC"
            (change)="selectedSSCCChange.emit(selectedSSCC); scannedBatchEle.focus();"
            [placeholder]="'Supplier SSCC Number' | locale" />
        </nz-input-group>
        <ng-template #ssccIcon>
          <i nz-icon nzType="border" nzTheme="outline"></i>
        </ng-template>
        <ng-template #clearSSCC>
          <i *ngIf="selectedSSCC !== ''" nz-icon class="ant-input-clear-icon" nzTheme="fill" nzType="close-circle"
            (click)="selectedSSCC = ''; ssccInput.focus();"></i>
        </ng-template>
      </nz-space-item>
      <nz-space-item>
        <nz-input-group [nzPrefix]="scanIcon" nzSize="large">
          <input nz-input #scannedBatchEle style="width: 100%;" [(ngModel)]="autoGenerated ? null : scannedBatch"
            (change)="batchScanned(scannedExpDateEle, undefined);" (keydown)="batchScanned(scannedExpDateEle, $event)"
            [placeholder]="autoGenerated ? 'Auto generated' : 'Scan/write batch no.' | locale" />
        </nz-input-group>
        <ng-template #scanIcon>
          <i nz-icon nzType="barcode" nzTheme="outline"></i>
        </ng-template>
      </nz-space-item>
      <nz-space-item>
        <nz-space style="width: 100%;">
          <nz-space-item style="width: 50%" [hidden]="!showExpireDateField">
            <nz-input-group>
              <input type="date" #scannedExpDateEle class="ant-input" style="width: 100%;height: 44px;" [(ngModel)]="scannedExpDate"
                (blur)="scannedQuantityEle.focus();" [placeholder]="'Exp. Date' | locale"
                (keydown)="expiryDateKeyDown($event)" (ngModelChange)="dateValueChanged();" />
            </nz-input-group>
          </nz-space-item>
          <nz-space-item style="width: 50%">
            <nz-input-number #scannedQuantityEle nzSize="large" style="width: 100%;" [(ngModel)]="scannedQuantity"
              [nzParser]="numberParser" (change)="scannedBatchEle.focus();" (nzBlur)="addNewBatch(undefined);"
              (keydown)="addNewBatch($event);" [nzPlaceHolder]="'Quantity' | locale"></nz-input-number>
          </nz-space-item>
        </nz-space>
      </nz-space-item>
    </nz-space>
  </nz-space-item>
  <nz-space-item *ngIf="dataDisplayMode === 'C'">
    <div nz-row [nzGutter]="[8, 8]">
      <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="12" *ngFor="let batchNumber of batchNumbers">
        <nz-card [nzTitle]="cardTitle" [nzExtra]="cardExtras" [nzActions]="[cardDeleteAction]">
          <nz-form-item *ngIf="displayMode === false && moduleStructure.module.AdditionalInformationParsed
          .ModuleApp === 'itm-wms-360'">
            <nz-form-label [nzSpan]="6">{{'SSCC' | locale}}</nz-form-label>
            <nz-form-control [nzSpan]="18">
              <input nz-input [(ngModel)]="batchNumber.U_ITM_WMS_SSCC" />
            </nz-form-control>
          </nz-form-item>
          <nz-form-item *ngIf="qtyProperty.Name !== 'UoMCountedQuantity'" [hidden]="!showMnfSerialField">
            <nz-form-label [nzSpan]="6">{{'Man. Batch' | locale}}</nz-form-label>
            <nz-form-control [nzSpan]="18">
              <input nz-input [(ngModel)]="autoGenerated ? 'Auto Generated' : batchNumber.MnfSerial" />
            </nz-form-control>
          </nz-form-item>
          <nz-form-item *ngIf="(displayMode === false || qtyProperty.Name === 'UoMCountedQuantity') && moduleStructure.module.AdditionalInformationParsed
          .ModuleApp === 'itm-wms-360'">
            <nz-form-label [nzSpan]="6">{{'Batch' | locale}}</nz-form-label>
            <nz-form-control [nzSpan]="18">
              <input nz-input [ngModel]="batchNumber.BatchNumber === '-' ? null : batchNumber.BatchNumber"
                [placeholder]="'Auto generated' | locale" />
            </nz-form-control>
          </nz-form-item>
          <nz-form-item *ngIf="(displayMode === false || qtyProperty.Name === 'UoMCountedQuantity' || this.moduleStructure.module.ObjectType === 'oInventoryGenEntry') && moduleStructure.module.AdditionalInformationParsed
          .ModuleApp !== 'itm-wms-360'">
            <nz-form-label [nzSpan]="6">{{'Batch' | locale}}</nz-form-label>
            <nz-form-control [nzSpan]="18">
              <input nz-input [(ngModel)]="batchNumber.BatchNumber" />
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label [nzSpan]="6">{{'Exp. Date' | locale}}</nz-form-label>
            <nz-form-control [nzSpan]="18">
              <nz-date-picker nz-input [nzFormat]="global.companyConfiguration.DateFormat"
                [(ngModel)]="batchNumber.ExpDate"></nz-date-picker>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label [nzSpan]="6">{{'Adm. Date' | locale}}</nz-form-label>
            <nz-form-control [nzSpan]="18">
              <nz-date-picker nz-input [nzFormat]="global.companyConfiguration.DateFormat"
                [(ngModel)]="batchNumber.AddmisionDate"></nz-date-picker>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item *ngIf="displayMode === false">
            <nz-form-label [nzSpan]="6">{{'Man. Date' | locale}}</nz-form-label>
            <nz-form-control [nzSpan]="18">
              <nz-date-picker nz-input [nzFormat]="global.companyConfiguration.DateFormat"
                [(ngModel)]="batchNumber.ManufacturingDate"></nz-date-picker>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item *ngIf="displayMode === false">
            <nz-form-label [nzSpan]="6">{{'Notes' | locale}}</nz-form-label>
            <nz-form-control [nzSpan]="18">
              <input nz-input [(ngModel)]="batchNumber.Notes" />
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label [nzSpan]="6">{{'Qty' | locale}}</nz-form-label>
            <nz-form-control [nzSpan]="18">
              <nz-input-number [(ngModel)]="batchNumber.Quantity" (change)="updateSelectedQty(batchNumber);">
              </nz-input-number>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item *ngIf="binActivated">
            <nz-form-label [nzSpan]="6">{{'Bin Location' | locale}}</nz-form-label>
            <nz-form-control [nzSpan]="18">
              <nz-select [(ngModel)]="batchNumber.BinLocation">
                <nz-option *ngFor="let binLocation of binLocations" [nzValue]="binLocation.AbsEntry"
                  [nzLabel]="binLocation.BinCode">
                </nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </nz-card>
        <ng-template #cardDeleteAction>
          <a nz-popconfirm [nzPopconfirmTitle]="'Are you sure you want to delete?' | locale"
            (nzOnConfirm)="deleteBatch(batchNumber);" style="font-size: 19px;">
            <i nz-icon nzType="delete" nzTheme="outline"></i>
          </a>
        </ng-template>
        <ng-template #cardTitle>
          <div *ngIf="qtyProperty.Name === 'UoMCountedQuantity'">
            {{'Batch' | locale}} {{autoGenerated ? ('Auto Generated' | locale) : '#' + batchNumber.BatchNumber}}
          </div>
          <div *ngIf="qtyProperty.Name !== 'UoMCountedQuantity' && moduleStructure.module.AdditionalInformationParsed
          .ModuleApp === 'itm-wms-360'">
            {{'Batch' | locale}} {{autoGenerated ? ('Auto Generated' | locale) : '#' + (batchNumber.MnfSerial == '' ?
            batchNumber.BatchNumber : batchNumber.MnfSerial)}}
          </div>
          <div *ngIf="qtyProperty.Name !== 'UoMCountedQuantity' && moduleStructure.module.AdditionalInformationParsed
          .ModuleApp !== 'itm-wms-360'">
            {{'Batch' | locale}} {{autoGenerated ? ('Auto Generated' | locale) : '#' + batchNumber.BatchNumber}}
          </div>
        </ng-template>
        <ng-template #cardExtras>
          <span class="text-span"
            *ngIf="batchNumber.Quantity != null && batchNumber.Quantity !== undefined && batchNumber.Quantity !== '' && batchNumber.Quantity !== '0' && batchNumber.Quantity !== 0 ">{{formatterQuantity(batchNumber.Quantity)}}</span>
        </ng-template>
      </div>
    </div>
  </nz-space-item>
  <nz-space-item *ngIf="dataDisplayMode === 'T'">
    <nz-table #bnTable [nzData]="batchNumbers">
      <thead>
        <tr>
          <th></th>
          <th *ngIf="displayMode === false">
            {{'SSCC' | locale}}
          </th>
          <th>
            {{'Batch' | locale}}
          </th>
          <th>
            {{'Exp. Date' | locale}}
          </th>
          <th *ngIf="displayMode === false">
            {{'Admission Date' | locale}}
          </th>
          <th *ngIf="displayMode === false">
            {{'Manufacturing Date ' | locale}}
          </th>
          <th *ngIf="displayMode === false">
            {{'Notes' | locale}}
          </th>
          <th>
            {{'Qty' | locale}}
          </th>
          <th *ngIf="binActivated">
            {{'Bin Location' | locale}}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let batchNumber of bnTable.data">
          <td>
            <a nz-popconfirm [nzPopconfirmTitle]="'Are you sure you want to delete?' | locale"
              (nzOnConfirm)="deleteBatch(batchNumber);">
              <i nz-icon nzType="close" nzTheme="outline"></i>
            </a>
          </td>
          <td *ngIf="displayMode === false">
            <input nz-input [(ngModel)]="batchNumber.U_ITM_WMS_SSCC" />
          </td>
          <td>
            <input nz-input [(ngModel)]="batchNumber.BatchNumber" />
          </td>
          <td>
            <nz-date-picker nz-input [nzFormat]="global.companyConfiguration.DateFormat"
              [(ngModel)]="batchNumber.ExpDate"></nz-date-picker>
          </td>
          <td *ngIf="displayMode === false">
            <nz-date-picker nz-input [nzFormat]="global.companyConfiguration.DateFormat"
              [(ngModel)]="batchNumber.AddmisionDate"></nz-date-picker>
          </td>
          <td *ngIf="displayMode === false">
            <nz-date-picker nz-input [nzFormat]="global.companyConfiguration.DateFormat"
              [(ngModel)]="batchNumber.ManufacturingDate"></nz-date-picker>
          </td>
          <td *ngIf="displayMode === false">
            <input nz-input [(ngModel)]="batchNumber.Notes" />
          </td>
          <td>
            <input nz-input [(ngModel)]="batchNumber.Quantity" (change)="updateSelectedQty(batchNumber);" />
          </td>
          <td *ngIf="binActivated">
            <nz-select style="width: 100%" [(ngModel)]="batchNumber.BinLocation">
              <nz-option *ngFor="let binLocation of binLocations" [nzValue]="binLocation.AbsEntry"
                [nzLabel]="binLocation.BinCode">
              </nz-option>
            </nz-select>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </nz-space-item>
</nz-space>
